import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons

function SubAdminLogModal() {
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleLogin = () => {
    if (!formData.email || !formData.password) {
      alert("Please fill in all fields.");
      return;
    }

    alert("Login successful!");
    setModalOpen(false);
  };

  return (
    <div>
      {/* Button to Open Modal */}
      <button
        className="bg-green-500 text-white px-4 py-2 w-40 rounded hover:bg-green-600"
        onClick={() => setModalOpen(true)}
      >
        Add sub Admin
      </button>

      {/* Modal */}
      {modalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-16 w-[500px] relative ">
            {/* Close Button */}
            <button
              className="absolute top-3 right-3 text-gray-500 hover:text-black text-sm"
              onClick={() => setModalOpen(false)}
            >
              ✖
            </button>

            <h2 className="text-2xl font-bold text-center mb-10 ">Sub Admin </h2>

            {/* Form */}
            <form className="space-y-4">
              <input
                type="email"
                name="email"
                placeholder="Email or Phone"
                value={formData.email}
                onChange={handleInputChange}
                className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400"
              />

              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"} // Toggle input type
                  name="password"
                  placeholder="Password"
                  value={formData.password}
                  onChange={handleInputChange}
                  className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400"
                />
                <span
                  onClick={() => setShowPassword((prev) => !prev)} // Toggle visibility
                  className="absolute right-3 top-3 cursor-pointer text-gray-400"
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              <div className="text-right">
                <a href="#" className="text-sm text-green-500 hover:underline">
                  Forgot password?
                </a>
              </div>

              <button
                type="button"
                onClick={handleLogin}
                className="w-full bg-green-500 text-white py-2 rounded-lg hover:bg-green-600 font-bold"
              >
                Log In
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default SubAdminLogModal;